// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex'
import VuePageStack from 'vue-page-stack'
import './color.scss'
import './main.scss'
import './assets/style/vant.scss'
import Bus from './components/bus/bus'
import {format} from '../tool/Date'
import {get,post} from '../tool/http'
import {verification} from '../tool/verification'
import {scrollscreen,getRandomNumber} from '../tool/until'
import  {Toast} from 'vant';
import { Dialog } from 'vant';
import axios from 'axios';
import mui from './assets/js/mui.js'
import { DropdownMenu, DropdownItem } from 'vant';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.prototype.$axios=axios;//axios
Vue.prototype.$Toast=Toast;//消息轻提示
Vue.prototype.$Dialog=Dialog;//消息提示框
Vue.prototype.$UserInfo=JSON.parse(localStorage.getItem('userInfo')); //登陆后保存的当前登陆人信息
Vue.prototype.$format=format; //日期格式化  this.$format(new Date(),'YYYY-MM-DD')
Vue.prototype.$get=get;
Vue.prototype.$post=post;
Vue.prototype.$verification=verification;
Vue.prototype.$scrollscreen=scrollscreen;
Vue.prototype.$getRandomNumber=getRandomNumber;
Vue.prototype.$Bus=Bus;
Vue.prototype.$Mui=mui;
Vue.prototype.$DropdownMenu=DropdownMenu;
Vue.prototype.$DropdownItem=DropdownItem;

Vue.config.productionTip = false;

Toast.setDefaultOptions({ forbidClick: true });


Vue.use(ElementUI)
Vue.use(VuePageStack, {router})
Vue.use(Dialog);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store
})



// WEBPACK FOOTER //
// ./src/main.js